export default ['type', 'status'];
